export default {
    logando: false,
    login: {},
    buscando: false,
    itemsAreaResponsavel: [],
    itemsTipoOs: [],
    itemsGrupoAtividade: [],
    itemsAtividade: [],
    itemsTarefasDisponiveis: [],
    janelas: [],
    anexos: [],
    formularios: [],
    itemsOrdemServico: [],

}